<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
    <el-date-picker
      v-model="dataTime"
      type="daterange"
      value-format='yyyy-MM-dd'
      style="margin-right: 10px"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-top: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 3781px"
      size="mini"
    >
      <el-table-column prop="date" label="日期" width="100">
        <template slot-scope="scope">{{ happenTimeFun(scope.row.date) == '9998-12-31'?'汇总':happenTimeFun(scope.row.date)}}</template>
      </el-table-column>
      <el-table-column prop="registerCount" label="注册人数" width="100" />
      <el-table-column prop="rechargeCount" label="充值人数" width="100" />
      <el-table-column prop="withdrawCount" label="提现人数" width="100" />
      <el-table-column prop="rechargeSum" label="充值USDT" width="100" />
      <el-table-column prop="withdrawSum" label="提现USDT" width="150" />
      <el-table-column prop="withdrawChargeSum" label="提现手续费USDT" width="100">
        <template slot="header">
          <div>提现手续费</div>
          <div>USDT</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="总余额USDT" width="100">
        <template slot="header">
          <div>总余额</div>
          <div>USDT</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalTeamAmount" label="团队余额USDT" width="100">
        <template slot="header">
          <div>团队余额</div>
          <div>USDT</div>
        </template>
      </el-table-column>
      <el-table-column prop="rechargeSumUsdc" label="充值USDC" width="170" />
       <el-table-column prop="rechargeSumTrx" label="充值TRX" width="100" />
       <el-table-column prop="rechargeSumBtc" label="充值BTC" width="170" />
       <el-table-column prop="rechargeSumEth" label="充值ETH" width="170" />
       <el-table-column prop="rechargeSumBnb" label="充值BNB" width="100" />
       <el-table-column prop="rechargeSumPol" label="充值POL" width="170" />
       <el-table-column prop="rechargeSumDai" label="充值DAI" width="170" />
       <el-table-column prop="rechargeSumDoge" label="充值DOGE" width="170" />

      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #CAFA83; color: #000;">签到</div>
        </template>
        <el-table-column prop="signInTotalAmount" label="签到金额" width="100" />
        <el-table-column prop="signInTotalCount" label="签到账号数" width="100" />
      </el-table-column>
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #FAE6FF; color: #000;">免费领取</div>
        </template>
        <el-table-column prop="freeCount" label="领取数量" width="110" />
        <el-table-column prop="freeAmount" label="领取金额" width="120" />
      </el-table-column>
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #81FFFF; color: #000;">投资理财</div>
        </template>
        <el-table-column prop="investCount" label="投资总人数" width="120" />
        <el-table-column prop="investCount2" label="实时投资总人数" width="120" />
        <el-table-column prop="investTotalAmount" label="出售USDT" width="100">
           <template slot="header">
               <div>投资总和</div>
               <div>（可退回）</div>
           </template>
       </el-table-column>
        <el-table-column prop="investProAmount" label="当日收益佣金" width="150" />
        <el-table-column prop="investCount3" label="当日投资人数" width="150" />
        <el-table-column prop="investSaleCount" label="当日赎回人数" width="150" />
        <el-table-column prop="investTotalBuy" label="当日买入USDT" width="150" />
        <el-table-column prop="investTotalSale" label="当日赎回USDT" width="150" />
        <el-table-column prop="invest1Amount" width="110">
           <template slot="header">
               <div>1天</div>
               <div>可退回总金额</div>
           </template>
       </el-table-column>
       <el-table-column prop="invest7Amount" width="110">
           <template slot="header">
               <div>7天</div>
               <div>可退回总金额</div>
           </template>
       </el-table-column>
       <el-table-column prop="invest14Amount" width="110">
           <template slot="header">
               <div>14天</div>
               <div>可退回总金额</div>
           </template>
       </el-table-column>
       <el-table-column prop="invest28Amount" width="110">
           <template slot="header">
               <div>28天</div>
               <div>可退回总金额</div>
           </template>
       </el-table-column>
       
      </el-table-column>
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #CAFA83; color: #000;">大逃杀</div>
        </template>
        <el-table-column prop="escapeBuyCount" label="投入人数" width="100" />
        <el-table-column prop="escapeBuyTimes" label="投入次数" width="100" />
        <el-table-column prop="escapeBuyAmount" label="投入金额" width="100" />
        <el-table-column prop="escapeWinAmount" label="躲避金额" width="100" />
        <el-table-column prop="escapeFailAmount" label="命中金额" width="100" />
        <el-table-column prop="escapeProAmount" label="命中手续费" width="100" />
        <el-table-column prop="escapeRewardAmount" label="奖励金额" width="100" />
        <el-table-column prop="escapeReturnAmount" label="返还金额" width="100" />
        <el-table-column prop="escapeEarnAmount" label="" width="150">
           <template slot="header">
          <div>盈亏</div>
          <div>投入-躲避-奖励-返还</div>
        </template>
        </el-table-column>
      </el-table-column>
      
      
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加载
      dataTime:['',''],
      startDate:'',
      endDate:''
    };
  },
  created(){
    let time = +new Date()
    let time1 = +new Date()-7*24*60*60*1000
    this.dataTime[0] = this.happenTimeFun(time1)
    this.dataTime[1] = this.happenTimeFun(time)
    console.log(this.dataTime)
  },
  mounted() {
    this.getRoleinfo();
  },
  methods: {
    happenTimeFun(num){
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d
},
    // 筛选
    select() {
      this.pageNum = 1;
      this.getRoleinfo();
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        startDate: this.dataTime[0],
        endDate:this.dataTime[1]
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.administrator
        .dataList(params)
        .then((res) => {
          this.tableData = res;
          // this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table tr:first-child{
  background-color: #d9ffe6 !important;
}
::v-deep .el-range-editor--mini .el-range-separator{
  line-height: 26px !important;
}
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}

</style>
